import React, { useState, useEffect } from 'react';
import { oneKlicks } from '../../../SDK/oneclick';
import { message, notification, Select } from 'antd';
import { toast } from 'react-toastify';
import { getuserdata } from '../../../services/apiService';
import { OneKlicksFileSDK } from '../../../SDK/OneKlicksFileSDK';
import { debugLog } from '../../../utils/debug';
const AddIncomeModel = ({ isOpen, toggle, onSubmit, fetchIncome }) => {
    const [transactionType, setTransactionType] = useState('');
    const [incomeType, setIncomeType] = useState('');
    const [errors, setErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);

    const [income, setIncome] = useState({
        incomeType: '',
        clientYes: '',
        investorEmail: '',
        investorPhone: '',
        investorName: '',
        otherDetails: '',
        amount: '',
        date: '',
        description: '',
        status: '',
        notes: '',
        toSendAccount: '',
        attachments: [],
        pickupLocation: '',
        pickupTime: '',
        referenceNumber: '',
        receipt: null
    });

    useEffect(() => {
        const fetchClients = async () => {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {};
            const orderBy = "id DESC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const investors = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog('get clients', investors.data);

            if (investors.success === true) {
                setClients(investors.data);
            }
            const userid = await getuserdata('id');
            debugLog('userid', userid);
            setIncome(prevIncome => ({
                ...prevIncome,
                toSendAccount: userid
            }));
        };
        fetchClients();
    }, []);

    const filterClients = (clients) => {
        return clients.filter(client => client.user_type === 'administrator' || client.user_type === 'staff' || client.user_type === 'ceo' || client.user_type === 'manager' || client.user_type === 'employee' || client.user_type === 'hr');
    }

    const validateForm = () => {
        const newErrors = {};
        debugLog('Starting form validation...');
        debugLog('Current form state:', {
            incomeType,
            transactionType,
            income
        });

        // Validate Income Type
        if (!incomeType) {
            newErrors.incomeType = 'Income type is required';
            debugLog('Validation failed: Income type is missing');
        }

        // Validate based on Income Type
        if (incomeType === 'investment') {
            if (!income.investorEmail) {
                newErrors.investorEmail = 'Investor email is required';
                debugLog('Validation failed: Investor email is missing');
            } else if (!/\S+@\S+\.\S+/.test(income.investorEmail)) {
                newErrors.investorEmail = 'Invalid email format';
                debugLog('Validation failed: Invalid email format');
            }

            if (!income.investorPhone) {
                newErrors.investorPhone = 'Investor phone is required';
                debugLog('Validation failed: Investor phone is missing');
            } else if (!/^\d{10}$/.test(income.investorPhone)) {
                newErrors.investorPhone = 'Phone must be 10 digits';
                debugLog('Validation failed: Invalid phone format');
            }

            if (!income.investorName) {
                newErrors.investorName = 'Investor name is required';
                debugLog('Validation failed: Investor name is missing');
            }
        }

        if (incomeType === 'other' && !income.otherDetails) {
            newErrors.otherDetails = 'Other details are required';
            debugLog('Validation failed: Other details are missing');
        }

        if ((incomeType === 'premium' || incomeType === 'client') && !income.clientYes) {
            newErrors.clientYes = 'Please select Yes/No';
            debugLog('Validation failed: Client selection is missing');
        }

        // Validate Transaction Type
        if (!transactionType) {
            newErrors.transactionType = 'Transaction type is required';
            debugLog('Validation failed: Transaction type is missing');
        }

        // Validate based on Transaction Type
        if (transactionType === 'cash') {
            if (!income.pickupLocation) {
                newErrors.pickupLocation = 'Pickup location is required';
                debugLog('Validation failed: Pickup location is missing');
            }
            if (!income.pickupTime) {
                newErrors.pickupTime = 'Pickup time is required';
                debugLog('Validation failed: Pickup time is missing');
            }
        }

        if (transactionType === 'card' || transactionType === 'bank') {
            if (!income.referenceNumber) {
                newErrors.referenceNumber = 'Reference number is required';
                debugLog('Validation failed: Reference number is missing');
            }
            if (!income.receipt) {
                newErrors.receipt = 'Receipt is required';
                debugLog('Validation failed: Receipt is missing');
            }
        }

        // Validate Amount
        if (!income.amount) {
            newErrors.amount = 'Amount is required';
        } else {
            // Remove commas and convert to number
            const cleanAmount = parseFloat(income.amount.replace(/,/g, ''));

            if (isNaN(cleanAmount) || cleanAmount <= 0) {
                newErrors.amount = 'Amount must be greater than 0';
            }
        }

        // Validate Date
        if (!income.date) {
            newErrors.date = 'Date is required';
        }

        // Validate To Send Account
        if (!income.toSendAccount) {
            newErrors.toSendAccount = 'To Send Account is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const formatAmount = (value) => {
        // Remove any non-digit characters except decimal point
        const number = value.replace(/[^\d.]/g, '');

        // Split into whole and decimal parts
        const parts = number.split('.');
        const wholePart = parts[0];
        const decimalPart = parts[1] || '';

        // Format whole part with commas
        const formattedWhole = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        // Combine with decimal part (max 2 decimal places)
        return decimalPart
            ? `${formattedWhole}.${decimalPart.slice(0, 2)}`
            : formattedWhole;
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            // Convert FileList to Array for multiple files
            const fileArray = Array.from(files);
            setIncome(prevIncome => ({
                ...prevIncome,
                [name]: fileArray
            }));
        } else {
            setIncome(prevIncome => ({
                ...prevIncome,
                [name]: value
            }));
        }


        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleCancel = () => {
        setIncome({
            incomeType: '',
            clientYes: '',
            investorEmail: '',
            investorPhone: '',
            investorName: '',
            otherDetails: '',
            amount: '',
            date: '',
            description: '',
            status: '',
            notes: '',
            attachments: [],
            pickupLocation: '',
            pickupTime: '',
            referenceNumber: '',
            receipt: null,
            date: ''
        });
        setIncomeType('');
        setTransactionType('');
        setErrors({});
        toggle();
    };

    // Function to handle file selection
    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        setIncome(prevIncome => ({
            ...prevIncome,
            attachments: [...prevIncome.attachments, ...files]
        }));
    };

    // Function to remove a file
    const handleRemoveFile = (index) => {
        setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
        setIncome(prevIncome => ({
            ...prevIncome,
            attachments: prevIncome.attachments.filter((_, i) => i !== index)
        }));
    };

    // Function to handle multiple file uploads
    const uploadMultipleFiles = async (files) => {
        const uploadedFileIds = [];
        const root = "income";
        const status = "public";

        for (const file of files) {
            try {
                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);
                if (uploadResult && uploadResult.fileId) {
                    uploadedFileIds.push(uploadResult.fileId);
                }
            } catch (error) {
                console.error('Error uploading file:', file.name, error);
                throw new Error(`Failed to upload file: ${file.name}`);
            }
        }

        return uploadedFileIds;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        debugLog('Starting form submission...');

        if (validateForm()) {
            try {
                setIsUploading(true);
                debugLog('Form validation passed');

                // Log all form data
                debugLog('Form Data:', {
                    ...income,
                    incomeType,
                    transactionType
                });

                let attachmentIds = [];

                // Handle file uploads if there are any
                if (income.attachments && income.attachments.length > 0) {
                    debugLog('Starting file uploads...');
                    try {
                        attachmentIds = await uploadMultipleFiles(income.attachments);
                        debugLog('Uploaded file IDs:', attachmentIds);
                    } catch (error) {
                        debugLog('File upload error:', error);
                        throw new Error(`File upload failed: ${error.message}`);
                    }
                }

                const tableSchema = "";
                const usertype = await getuserdata('user_type');
                debugLog('User type:', usertype);

                const userid = await getuserdata('id');
                debugLog('User ID:', userid);

                const timestamp = new Date().getTime();
                const tableName = "income";
                const data = {
                    add_by: userid,
                    transaction_id: timestamp,
                    incomeType: incomeType,
                    clientYes: income.clientYes,
                    investorEmail: income.investorEmail,
                    investorPhone: income.investorPhone,
                    investorName: income.investorName,
                    otherDetails: income.otherDetails,
                    amount: income.amount,
                    date: income.date,
                    description: income.description,
                    status: usertype === 'administrator' ? "active" : "pending",
                    notes: income.notes,
                    attachments: attachmentIds.join(','), // Store file IDs as comma-separated string
                    pickupLocation: income.pickupLocation || "",
                    pickupTime: income.pickupTime || "",
                    referenceNumber: income.referenceNumber || "",
                    receipt: income.receipt || "",
                    transactionType: transactionType,
                    date: income.date,
                    toSendAccount: income.toSendAccount
                };

                debugLog('Prepared data for API:', data);

                // Validate required data before API call
                if (!data.add_by) {
                    debugLog('User ID not found');
                    throw new Error('User ID not found. Please login again.');
                }



                const condition = {};
                debugLog('Calling oneKlicks.create...');
                const addIncome = await oneKlicks.create(tableSchema, tableName, data, condition);
                debugLog('API Response addIncome:', addIncome);

                if (addIncome.success === true) {
                    debugLog('Income added successfully, updating balance...');
                    const tableSchema = "";
                    const tableName = "balance";
                    const conditions = {
                        account_id: data.toSendAccount
                    };
                    const orderBy = "id DESC";
                    const search = {};
                    const pagination = {};
                    const margedata = [];
                    const checkbalance = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                    debugLog('Balance check response:', checkbalance);

                    if (checkbalance.success === true && checkbalance.data.length > 0) {
                        const totalbalance = parseFloat(checkbalance.data[0].amount) + parseFloat(data.amount);
                        debugLog('Updating balance to:', totalbalance);
                        const condition = { id: checkbalance.data[0].id };
                        const updatebalancedata = {
                            amount: totalbalance
                        };
                        const updatebalance = await oneKlicks.update(tableSchema, tableName, updatebalancedata, condition);

                        const balanceSheetData = {
                            account_id: data.toSendAccount,
                            transaction_id: data.transaction_id,
                            credit: data.amount,
                            debit: 0,
                            balance: totalbalance,
                            date: income.date,
                            description: income.description,
                            status: "active"
                        };
                        debugLog('Adding balance sheet entry:', balanceSheetData);
                        const addblaanceseet = await oneKlicks.create(tableSchema, "balance_sheet", balanceSheetData, {});
                        debugLog('Balance sheet update response:', addblaanceseet);
                    } else {
                        debugLog('No existing balance found, creating new balance record');
                        // Create new balance record if none exists
                        const newBalanceData = {
                            account_id: data.toSendAccount,
                            amount: data.amount,
                            status: "active"
                        };
                        const createBalance = await oneKlicks.create(tableSchema, tableName, newBalanceData, {});

                        const balanceSheetData = {
                            account_id: data.toSendAccount,
                            transaction_id: data.transaction_id,
                            credit: data.amount,
                            debit: 0,
                            balance: data.amount,
                            date: income.date,
                            description: income.notes,
                            status: "active"
                        };
                        const addblaanceseet = await oneKlicks.create(tableSchema, "balance_sheet", balanceSheetData, {});
                        debugLog('New balance creation response:', addblaanceseet);
                    }
                    message.success("Income added successfully");
                    toast.success("Income added successfully");

                    // Only call onSubmit if it's a function
                    if (typeof onSubmit === 'function') {
                        onSubmit(income);
                    }
                    fetchIncome();
                    handleCancel();
                } else {
                    debugLog('API Error:', addIncome);
                    throw new Error(addIncome.message || 'Failed to add income');
                }
            } catch (error) {
                debugLog('Error in handleSubmit:', error);

                // Handle specific error cases
                if (error.message.includes('User ID not found')) {
                    message.error('Session expired. Please login again.');
                    toast.error('Session expired. Please login again.');
                } else if (error.message.includes('Invalid amount')) {
                    message.error('Please enter a valid amount');
                    toast.error('Please enter a valid amount');
                } else if (error.message.includes('File upload failed')) {
                    message.error(error.message);
                    toast.error(error.message);
                } else if (error.response) {
                    // Handle API error response
                    message.error(error.response.data?.message || 'Failed to add income');
                    toast.error(error.response.data?.message || 'Failed to add income');
                } else {
                    // Handle general errors
                    message.error(error.message || 'An error occurred while adding income');
                    toast.error(error.message || 'An error occurred while adding income');
                }
            } finally {
                setIsUploading(false);
                setLoading(false);
            }
        } else {
            debugLog('Form validation failed');
            setLoading(false);
        }
    };

    if (!isOpen) return null;
    
    return (
        <div className="modal fade dc-loginformpop show" style={{ display: 'block', paddingRight: '17px', background: '#00000085' }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ width: '50%', maxWidth: '500px' }}>
                <div className="dc-modalcontent modal-content">
                    <div className="dc-loginformholds" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        <div className="dc-loginheader" style={{ paddingLeft: '0px' }}>
                            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Add Income</span>
                            <a href="#" className="dc-closebtns close dc-close" onClick={handleCancel} aria-label="Close">
                                <i className="fa fa-times"></i>
                            </a>
                        </div>
                        <form onSubmit={handleSubmit} className="dc-html-form" style={{ marginTop: 24 }}>
                            <div className="form-group">
                                <label htmlFor="incomeType"><span style={{ color: 'red' }}>*</span> Income Type</label>
                                <select
                                    id="incomeType"
                                    name="incomeType"
                                    className={`dc-form-control ${errors.incomeType ? 'is-invalid' : ''}`}
                                    required
                                    value={incomeType}
                                    onChange={(e) => {
                                        setIncomeType(e.target.value);
                                        handleInputChange(e);
                                    }}
                                >
                                    <option value="">Select income type</option>
                                    <option value="investment">Investment</option>
                                    <option value="premium">Premium</option>
                                    <option value="client">Client</option>
                                    <option value="other">Other</option>
                                </select>
                                {errors.incomeType && <div className="invalid-feedback">{errors.incomeType}</div>}
                            </div>

                            {incomeType === 'investment' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="investorEmail"><span style={{ color: 'red' }}>*</span> Investor Email</label>
                                        <input
                                            type="email"
                                            id="investorEmail"
                                            name="investorEmail"
                                            className={`dc-form-control ${errors.investorEmail ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter investor Email"
                                            value={income.investorEmail}
                                            onChange={handleInputChange}
                                        />
                                        {errors.investorEmail && <div className="invalid-feedback">{errors.investorEmail}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="investorPhone"><span style={{ color: 'red' }}>*</span> Investor Phone</label>
                                        <input
                                            type="tel"
                                            id="investorPhone"
                                            name="investorPhone"
                                            className={`dc-form-control ${errors.investorPhone ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter investor Phone"
                                            value={income.investorPhone}
                                            onChange={handleInputChange}
                                        />
                                        {errors.investorPhone && <div className="invalid-feedback">{errors.investorPhone}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="investorName"><span style={{ color: 'red' }}>*</span> Investor Name</label>
                                        <input
                                            type="text"
                                            id="investorName"
                                            name="investorName"
                                            className={`dc-form-control ${errors.investorName ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter investor Name"
                                            value={income.investorName}
                                            onChange={handleInputChange}
                                        />
                                        {errors.investorName && <div className="invalid-feedback">{errors.investorName}</div>}
                                    </div>
                                </>
                            )}

                            {(incomeType === 'premium' || incomeType === 'client') && (
                                <div className="form-group">
                                    <label htmlFor="clientYes"><span style={{ color: 'red' }}>*</span> Select Client</label>
                                    <div className="client-selector-container">
                                        <Select
                                            id="clientYes"
                                            name="clientYes"
                                            className={`${errors.clientYes ? 'is-invalid' : ''}`}
                                            placeholder="Select a Client"
                                            value={income.clientYes || undefined}
                                            onChange={(value) => {
                                                setIncome(prev => ({
                                                    ...prev,
                                                    clientYes: value
                                                }));
                                                if (errors.clientYes) {
                                                    setErrors(prev => ({
                                                        ...prev,
                                                        clientYes: ''
                                                    }));
                                                }
                                            }}
                                            options={[
                                                { value: 'need', label: 'Need' },
                                                { value: 'manual', label: 'Manual' },
                                                ...filterClients(clients).map(client => ({
                                                    value: client.id,
                                                    label: `${client.display_name} - ${client.email}`
                                                }))
                                            ]}
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            style={{
                                                width: '100%',
                                                color: '#000000',
                                                backgroundColor: '#ffffff',
                                                height: '44px',
                                                borderColor: '#4e5779',
                                                boxShadow: 'none',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    </div>
                                    {errors.clientYes && <div className="invalid-feedback">{errors.clientYes}</div>}
                                </div>
                            )}

                            {incomeType === 'other' && (
                                <div className="form-group">
                                    <label htmlFor="otherDetails"><span style={{ color: 'red' }}>*</span> Other Details</label>
                                    <input
                                        type="text"
                                        id="otherDetails"
                                        name="otherDetails"
                                        className={`dc-form-control ${errors.otherDetails ? 'is-invalid' : ''}`}
                                        required
                                        placeholder="Enter details"
                                        value={income.otherDetails}
                                        onChange={handleInputChange}
                                    />
                                    {errors.otherDetails && <div className="invalid-feedback">{errors.otherDetails}</div>}
                                </div>
                            )}

                            <div className='form-group'>
                                <label htmlFor="date"><span style={{ color: 'red' }}>*</span> Date</label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    className={`dc-form-control ${errors.date ? 'is-invalid' : ''}`}
                                    required
                                    value={income.date}
                                    onChange={handleInputChange}
                                />
                                {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                            </div>


                            <div className="form-group">
                                <label htmlFor="transactionType"><span style={{ color: 'red' }}>*</span> Transaction Type</label>
                                <select
                                    id="transactionType"
                                    name="transactionType"
                                    className={`dc-form-control ${errors.transactionType ? 'is-invalid' : ''}`}
                                    required
                                    value={transactionType}
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        handleInputChange(e);
                                    }}
                                >
                                    <option value="">Select transaction type</option>
                                    <option value="cash">Cash</option>
                                    <option value="card">Card</option>
                                    <option value="bank">Bank Transfer</option>
                                    <option value="upi">UPI</option>
                                </select>
                                {errors.transactionType && <div className="invalid-feedback">{errors.transactionType}</div>}
                            </div>

                            {transactionType === 'cash' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="pickupLocation"><span style={{ color: 'red' }}>*</span> Cash Pickup Location</label>
                                        <input
                                            type="text"
                                            id="pickupLocation"
                                            name="pickupLocation"
                                            className={`dc-form-control ${errors.pickupLocation ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter cash pickup location"
                                            value={income.pickupLocation}
                                            onChange={handleInputChange}
                                        />
                                        {errors.pickupLocation && <div className="invalid-feedback">{errors.pickupLocation}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pickupTime"><span style={{ color: 'red' }}>*</span> Pickup Time</label>
                                        <input
                                            type="datetime-local"
                                            id="pickupTime"
                                            name="pickupTime"
                                            className={`dc-form-control ${errors.pickupTime ? 'is-invalid' : ''}`}
                                            required
                                            value={income.pickupTime}
                                            onChange={handleInputChange}
                                        />
                                        {errors.pickupTime && <div className="invalid-feedback">{errors.pickupTime}</div>}
                                    </div>
                                </>
                            )}

                            {(transactionType === 'card' || transactionType === 'bank' || transactionType === 'upi') && (
                                <div className="form-group">
                                    <label htmlFor="attachments"><span style={{ color: 'red' }}>*</span> Attachments</label>
                                    <input
                                        type="file"
                                        id="attachments"
                                        name="attachments"
                                        className={`dc-form-control ${errors.attachments ? 'is-invalid' : ''}`}
                                        multiple
                                        onChange={handleFileSelect}
                                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                    />
                                    {errors.attachments && <div className="invalid-feedback">{errors.attachments}</div>}

                                    {/* File Preview Section */}
                                    {selectedFiles.length > 0 && (
                                        <div className="mt-3">
                                            <h6>Selected Files:</h6>
                                            <div className="selected-files-list">
                                                {selectedFiles.map((file, index) => (
                                                    <div key={index} className="selected-file-item" style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        padding: '8px',
                                                        margin: '4px 0',
                                                        backgroundColor: '#f8f9fa',
                                                        borderRadius: '4px'
                                                    }}>
                                                        <span style={{ flex: 1 }}>{file.name}</span>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveFile(index)}
                                                            className="btn btn-sm btn-danger"
                                                            style={{ marginLeft: '8px' }}
                                                        >
                                                            <i className="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="form-group">
                                <label htmlFor="amount"><span style={{ color: 'red' }}>*</span> Amount</label>
                                <input
                                    type="text"
                                    id="amount"
                                    name="amount"
                                    className={`dc-form-control ${errors.amount ? 'is-invalid' : ''}`}
                                    placeholder="0.00"
                                    required
                                    value={income.amount}
                                    onChange={handleInputChange}
                                    style={{ flex: 1 }}
                                />
                                {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="description"><span style={{ color: 'red' }}>*</span>To Send Account</label>
                                <Select
                                    id="toSendAccount"
                                    name="toSendAccount"
                                    className={`${errors.toSendAccount ? 'is-invalid' : ''}`}
                                    placeholder="Select a Client"
                                    value={income.toSendAccount || undefined}
                                    onChange={(value) => {
                                        setIncome(prev => ({
                                            ...prev,
                                            toSendAccount: value
                                        }));
                                        if (errors.toSendAccount) {
                                            setErrors(prev => ({
                                                ...prev,
                                                toSendAccount: ''
                                            }));
                                        }
                                    }}
                                    options={[
                                        { value: '0', label: 'MeddyList Account' },
                                        ...filterClients(clients).map(client => ({
                                            value: client.id,
                                            label: `${client.display_name} - ${client.email}`
                                        }))
                                    ]}
                                    showSearch
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{
                                        width: '100%',
                                        color: '#000000',
                                        backgroundColor: '#ffffff',
                                        height: '44px',
                                        borderColor: '#4e5779',
                                        boxShadow: 'none',
                                        borderRadius: '4px'
                                    }}
                                />
                                {errors.toSendAccount && <div className="invalid-feedback">{errors.toSendAccount}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="notes">Notes</label>
                                <textarea
                                    id="notes"
                                    name="notes"
                                    className="dc-form-control"
                                    rows="4"
                                    placeholder="Enter any additional notes"
                                    value={income.notes}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="dc-btn dc-update-servicess"
                                    style={{ width: '100%' }}
                                    disabled={isUploading || loading}
                                >
                                    {isUploading || loading ? 'Uploading...' : 'Add Income'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '44px',
        maxHeight: '44px',
        width: '100%',
        minWidth: '200px',
        borderColor: '#4e5779',
        boxShadow: 'none',
        backgroundColor: '#ffffff',
        '&:hover': {
            borderColor: '#4e5779'
        }
    }),
    input: (provided) => ({
        ...provided,
        color: '#000000',
        margin: '0px'
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000000'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#666666',
        margin: '0px'
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        backgroundColor: '#ffffff'
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#4e5779' : '#ffffff',
        color: state.isSelected ? '#ffffff' : '#000000',
        '&:hover': {
            backgroundColor: '#4e5779',
            color: '#ffffff'
        }
    })
};

export default AddIncomeModel;

